import { render, staticRenderFns } from "./JobCardContent.vue?vue&type=template&id=42872a5a"
import script from "./JobCardContent.vue?vue&type=script&lang=js"
export * from "./JobCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports